'use client';

import React from 'react';
import { Calendar as CalendarIcon, BookOpen, HelpCircle, LogOut, RefreshCw } from 'lucide-react';
import type { View } from '../../types';

interface TopNavBarProps {
  currentView: View;
  onViewChange: (view: View) => void;
  onLogout?: () => void;
  onRefresh?: () => void;
}

export function TopNavBar({ currentView, onViewChange, onLogout, onRefresh }: TopNavBarProps) {
  const getButtonClass = (view: View) => {
    const isActive = currentView === view ||
      (view === 'main' && currentView === 'booking');
    return `p-3 rounded-full transition-all duration-200 ${
      isActive
        ? 'bg-blue-500 text-white shadow-lg'
        : 'bg-white text-gray-600 hover:bg-gray-50 shadow-md'
    }`;
  };

  return (
    <div className="sticky top-0 z-50 bg-white border-b border-gray-200">
      <div className="px-4 py-3">
        <div className="flex items-center justify-between">
          {/* 새로고침 버튼 */}
          {onRefresh ? (
            <button
              onClick={onRefresh}
              className="p-2 hover:bg-blue-50 rounded-full transition-colors"
            >
              <RefreshCw className="w-5 h-5 text-blue-500" />
            </button>
          ) : (
            <div className="w-9"></div>
          )}

          {/* 중앙 네비게이션 */}
          <div className="flex items-center justify-center gap-6">
            <button
              onClick={() => onViewChange('main')}
              className={getButtonClass('main')}
              title="예약"
            >
              <CalendarIcon className="w-6 h-6" />
            </button>

            <button
              onClick={() => onViewChange('resources')}
              className={getButtonClass('resources')}
              title="학습 자료"
            >
              <BookOpen className="w-6 h-6" />
            </button>

            <button
              onClick={() => onViewChange('qna')}
              className={getButtonClass('qna')}
              title="Q&A"
            >
              <HelpCircle className="w-6 h-6" />
            </button>
          </div>

          {/* 로그아웃 버튼 */}
          {onLogout ? (
            <button
              onClick={onLogout}
              className="p-2 hover:bg-red-50 rounded-full transition-colors"
            >
              <LogOut className="w-5 h-5 text-red-500" />
            </button>
          ) : (
            <div className="w-9"></div>
          )}
        </div>
      </div>
    </div>
  );
}
